import Axios from 'axios'
import LogonService from '@/services/LogonService'
import SettingsService from '@/services/SettingsService'
import qs from 'qs'

const request = (store, config) => {
  let axiosConfig = {
    baseURL: config.onlyBaseUrl ? SettingsService.apiUrl : SettingsService.apiUrl + '/api/v1',
    headers: {
      'Access-Control-Allow-Origin': SettingsService.siteUrl
    }
  }
  let accessToken = store.getters.getAccessToken
  if (accessToken) axiosConfig.headers['Authorization'] = 'Bearer ' + accessToken
  return Axios.create(axiosConfig)
}

export default class Ajax {
  store

  constructor (store) {
    this.store = store
  }

  get (url, searchParams, then, config = {}) {
    if (!config.hiddenLoading) this.store.dispatch('loading', true)
    config.params = searchParams
    config.paramsSerializer = function (params) {
      return qs.stringify(params, {indices: false})
    }
    request(this.store, config)
      .get(url, config)
      .then(response => response.data)
      .then(data => then(data))
      .catch(e => {
        this.ccatch(e, () => {
          this.get(url, searchParams, then, config)
        })
      })
      .finally(() => {
        if (!config.hiddenLoading) this.store.dispatch('loading', false)
      })
  }

  post (url, data, then, config = {}) {
    if (!config.hiddenLoading) this.store.dispatch('loading', true)
    request(this.store, config)
      .post(url, data, config)
      .then(response => response.data)
      .then(data => then(data))
      .catch(e => {
        if (url !== '/login') {
          this.ccatch(e, () => {
            this.post(url, data, then, config)
          })
        } else {
          then({requestError: e})
        }
      })
      .finally(() => {
        if (!config.hiddenLoading) this.store.dispatch('loading', false)
      })
  }

  ccatch (e, then) {
    if (e.response && e.response.status === 401) {
      LogonService.refreshToken(this, this.store, then)
    } else {
      console.error(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/ajax/index.js